import React from 'react';
import { DAYS, TIME_BLOCKS } from '../constants';

// The weekly 7×12 grid of two-hour blocks, in the user's own wall-clock time.
// value is availabilityLocal ([{ day: 'Mon', start, end }]); onChange gets the new list.
// A day name or a time label fills or clears that whole column or row.
const SHORTS = DAYS.map(d => d.substring(0, 3));
export const slotOn = (list, day, start) => list.some(s => s.day === day && s.start === start);

export default function AvailabilityGrid({ value, onChange }) {
  const toggleSlot = (short, block) => onChange(slotOn(value, short, block.start)
    ? value.filter(s => !(s.day === short && s.start === block.start))
    : [...value, { day: short, start: block.start, end: block.end }]);

  const toggleDay = (short) => {
    const allOn = TIME_BLOCKS.every(b => slotOn(value, short, b.start));
    onChange(allOn
      ? value.filter(s => s.day !== short)
      : [...value, ...TIME_BLOCKS.filter(b => !slotOn(value, short, b.start)).map(b => ({ day: short, start: b.start, end: b.end }))]);
  };

  const toggleBlock = (block) => {
    const allOn = SHORTS.every(short => slotOn(value, short, block.start));
    onChange(allOn
      ? value.filter(s => s.start !== block.start)
      : [...value, ...SHORTS.filter(short => !slotOn(value, short, block.start)).map(short => ({ day: short, start: block.start, end: block.end }))]);
  };

  return (
    <>
      <div className="grid-help">
        <span>Tap a <strong>day</strong> or a <strong>time</strong> to fill or clear that whole column or row.</span>
        <button type="button" className="link-btn" onClick={() => onChange([])} disabled={!value.length}>Clear all</button>
      </div>
      <div className="weekly-grid">
        <div className="time-corner">Local time</div>
        {DAYS.map(d => <button type="button" key={d} className="time-header" onClick={() => toggleDay(d.substring(0, 3))} title={`Toggle all of ${d}`}>{d.substring(0, 3)}</button>)}
        {TIME_BLOCKS.map(block => (
          <React.Fragment key={block.label}>
            <button type="button" className="time-label" onClick={() => toggleBlock(block)} title={`Toggle ${block.label} on every day`}>{block.label}</button>
            {DAYS.map(day => {
              const short = day.substring(0, 3);
              const on = slotOn(value, short, block.start);
              return <button type="button" key={short + block.start} className={`time-slot ${on ? 'selected' : ''}`} aria-pressed={on} aria-label={`${day} ${block.label}`} onClick={() => toggleSlot(short, block)} />;
            })}
          </React.Fragment>
        ))}
      </div>
    </>
  );
}
